import { createStore } from 'vuex'
import { auth } from './auth.module'

const store = createStore({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    auth
  }
})

export function useStore() {
  return store
}

export default store